import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {inject} from '@angular/core';
import {IIdentityClaim} from '../azure-b2c/azure-b2c.guard';
import {ROUTES} from '../../../../routes.enum';
import {SOFT_LAUNCH_BLOCK_REASON_KEY} from '../../soft-launch/soft-launch.constants';

/**
 * The message guard to check if the user has a block text claim.
 * @param route
 * @param state
 */
export const messageGuard: CanActivateFn = (route, state) => {
  /**
   * The auth service to get claims.
   */
  const authService = inject(AuthService);
  /**
   * The router to navigate to redirect url.
   */
  const router = inject(Router);
  // If BlockText has  value, route to page that shows error
  if (authService.getIdentityClaim(IIdentityClaim.BlockText)) {
    return true;
  }
  // Prod Soft Launch (AB172621): a user turned away by a Soft Launch restriction
  // has a block-reason marker but no BlockText claim — allow the message page so
  // it can show the restriction copy instead of bouncing back to the app.
  if (sessionStorage.getItem(SOFT_LAUNCH_BLOCK_REASON_KEY)) {
    return true;
  }
  // Else go back to root
  // ToDO: May cause a loop? Need to check.
  return router.navigate([ROUTES.APP]);
};
